import styled from "styled-components";
import Button from "@mui/material/Button";

export const HeaderBar = styled.div`
  position: relative;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 12vh;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 4px #00000029;
  opacity: 1;
  display: flex;
  justify-content: space-between;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 48px;
  margin-left: 70px;
`;

export const NavItem = styled(Button)`
  color: ${({ theme, selected }) => {
    if (selected) {
      return theme.colors.green;
    } else {
      return theme.colors.darkgrey;
    }
  }};
  font: normal normal 600 1vw/1.1vw Open Sans;
  text-transform: uppercase;
  margin-right: 5px;
`;

export const NavContainer = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  //margin: auto 10px;
`;

export const UserDetailContainer = styled.div`
  height: fit-content;
  width: fit-content;
  margin-left: 14px;
  margin-right: 30px;
`;
export const UserName = styled.div`
  text-align: left;
  height: fit-content;
  width: 200px;
  font: normal normal 600 14px/19px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const UserType = styled.div`
  text-transform: capitalize;
  text-align: left;
  height: fit-content;
  font: normal normal normal 14px/19px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.lightgrey;
  }};
`;

export const HeaderActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;
